import { useState, useCallback } from "react";
import apiClient from "../utils/apiClient";
// Adjust the path according to your project structure

const useAPI = (initialEndpoint, initialMethod) => {
  const [endpoint, setEndpoint] = useState(initialEndpoint);
  const [method, setMethod] = useState(initialMethod);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(
    async (requestData = null) => {
      setLoading(true);
      setError(null);

      try {
        let response;
        switch (method) {
          case "GET":
            response = await apiClient.get(endpoint);
            break;
          case "POST":
            response = await apiClient.post(endpoint, requestData);
            break;
          case "PUT":
            response = await apiClient.put(endpoint, requestData);
            break;
          case "PATCH":
            response = await apiClient.patch(endpoint, requestData);
            break;
          case "DELETE":
            response = await apiClient.delete(endpoint);
            break;
          default:
            throw new Error("Unsupported method");
        }
        setData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [endpoint, method]
  );

  const refetch = useCallback(
    (requestData = null) => {
      fetchData(requestData);
    },
    [fetchData]
  );

  return { data, loading, error, refetch, setEndpoint, setMethod };
};

export default useAPI;
